import React from 'react';
import PropTypes from 'prop-types';

import { Card, CardText } from 'react-md';

import { fromJS } from 'immutable';

import ItemField from '../../../Components/ItemField/ItemField';
import withToggleView from '../../../Components/ToggleView/ToggleView';

const style = { maxWidth: 320 };

const EditContracts = () => <div className="content">not available</div>;

const BlockContracts = ({ party, strings, i18n, mode, setViewMode, id }) => {
  const getSubscriber = subscriber => {
    if (!subscriber) return undefined;
    const render = [];
    render.push(subscriber.name);
    return render.toString();
  };

  return mode === 'view' ? (
    <div className="content" key={`contracts-${id}`}>
      {party && Array.isArray(party.contracts)
        ? party.contracts.map(contract => (
            // eslint-disable-next-line react/jsx-indent
            <Card style={style} className="md-block-cards" key={contract.id}>
              <CardText>
                <div className="group">
                  <ItemField
                    label={strings['parties.grid.column.contractNumber.label'] || 'Numéro de contrat'}
                    value={contract.contractNumber}
                    name="contract.id"
                    type="link"
                    route={`/contracts/edit?contract_number=${contract.contractNumber}`}
                    optional
                  />
                  <ItemField
                    label={strings['parties.grid.column.status.label'] || 'Statut'}
                    value={contract.contractStatus}
                    name="contract.status"
                    optional
                    i18n={i18n}
                  />
                  <ItemField
                    label={strings['parties.grid.column.appliable_conditions_date.label'] || 'Activation'}
                    value={contract.startDate}
                    name="contract.startDate"
                    type="date"
                    optional
                    i18n={i18n}
                  />
                </div>
                <ItemField
                  label={strings['parties.grid.column.subscriber.label'] || 'Souscripteur'}
                  value={getSubscriber(contract.subscriber)}
                  name="contract.subscriber"
                  type={contract.subscriber ? 'link' : 'string'}
                  route={contract.subscriber ? `/party/${contract.subscriber.code}` : ''}
                  optional
                  i18n={i18n}
                />
              </CardText>
            </Card>
          ))
        : ''}
    </div>
  ) : (
    <EditContracts setViewMode={setViewMode}>not available</EditContracts>
  );
};

BlockContracts.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string),
  // eslint-disable-next-line react/forbid-prop-types
  party: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  i18n: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  contractStatus: PropTypes.object,
  mode: PropTypes.oneOf(['edit', 'view']).isRequired, // HOC withToggleView
  setViewMode: PropTypes.func.isRequired, // HOC withToggleView,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

BlockContracts.defaultProps = {
  party: {},
  i18n: fromJS({}),
  strings: {},
  contractStatus: fromJS({}),
};

const config = {
  title: 'party.edit.block.contracts.label',
  defaultTitle: 'Contracts',
  name: 'contracts',
  active: false,
};

export default withToggleView(BlockContracts, config);
